import { z } from "zod";

import { cityOrRegionField, isPlausibleGraduationYear, requiredString } from "./fields";

const requiredSelection = (message: string) =>
	z.union([requiredString(message), z.number()]).refine((value) => String(value).trim() !== "", message);

export const educationSchema = z.object({
	schoolName: requiredString("Please enter a school name"),
	// Checked on its own, not with the country appended. The form used to validate
	// `${schoolLocation}, ${country}` and then save by splitting `schoolLocation`
	// alone, so a location the gate had never seen went to the server.
	schoolLocation: cityOrRegionField("Please enter a school city or region"),
	country: requiredString("Please select a country"),
	educationLevel: requiredString("Please enter a certification"),
	fieldOfStudy: requiredString("Please enter what you studied"),
	fieldOfStudyCategory: requiredString("Please select a field of study"),
	gMonth: requiredSelection("Please select graduation month"),
	gYear: requiredSelection("Please enter graduation year").refine(
		isPlausibleGraduationYear,
		"Please enter a plausible graduation year",
	),
});

export type EducationFormValues = z.infer<typeof educationSchema>;
